
import { PrivateInterceptorsPR } from "../../../Base/interceptors/PrivateinterceptorsPR";
import { PublicInterceptorPR } from "../../../Base/interceptors/PublicInterceptorsPR";

export const getPreguntasEncuesta = async (IdEncuesta, QR, CodigoLink) => {
    return await PublicInterceptorPR(`Ext/Encuestas/Encuesta/${IdEncuesta}`, 'POST', {QR, CodigoLink});
}

export const guardarRespuestas = async (respuestas) => {
    return await PublicInterceptorPR(`Ext/Encuestas/Respuestas/save`, 'POST', respuestas);
}